function ordersShoMore (){
    const myAccountPage = document.querySelector('.woocommerce-MyAccount-content');
    if(myAccountPage){
    const showOrdersButtons = myAccountPage.querySelectorAll('[data-orders-show-more]');
        showOrdersButtons.forEach( e => {
            e.addEventListener('click', () =>{
                e.previousElementSibling.classList.toggle('opened');
                if(e.previousElementSibling.classList.contains('opened')){
                    e.textContent = 'Pokaż mniej';
                } else {
                    e.textContent = 'Pokaż więcej';
                }
            });
        });
    }
}

export default {ordersShoMore};


// WEBPACK FOOTER //
// ./src/scripts/my-account-orders-show-more.js